import { PaymentRequirement } from "../../../invoices/models/InvoiceModel";

export class PaymentUtils {
    public static getPaymentRequirementText(requirement: PaymentRequirement): string {
        switch (requirement) {
            case PaymentRequirement.beforeDelivery: return "B4 Delivery";
            case PaymentRequirement.atDelivery: return "At Delivery";
            case PaymentRequirement.atDeliveryOrLater: return "At Delivery / Later";
            case PaymentRequirement.later: return "Later";
        }

        return "";
    }
}